import { Member } from '@sendbird/chat/groupChannel';
import { useMemo } from 'react';
import { useTranslate } from 'ra-core';
import { Checkbox } from '../../components/ui/checkbox';
import { type UserDto } from '../../hooks/useGetUsers';

export const ChannelUserCardCheckbox = (props: {
  user: UserDto;
  selectedUsers: UserDto[];
  preSelectedMembers?: Member[];
  disabled?: boolean;
  onCheckedChange?: (checked: boolean) => void;
}) => {
  const translate = useTranslate();
  const isPreSelected = useMemo(
    () =>
      props.preSelectedMembers?.some(
        (u) => u.userId === props.user.id.toString()
      ) ?? false,
    [props.preSelectedMembers, props.user.id]
  );
  const isSelected = useMemo(
    () => props.selectedUsers.some((u) => u.id === props.user.id),
    [props.selectedUsers, props.user.id]
  );

  return (
    <Checkbox
      checked={isPreSelected || isSelected}
      disabled={isPreSelected || props.disabled}
      onCheckedChange={props.onCheckedChange}
      aria-label={translate('chat.selectUser', {
        name: props.user.displayName,
      })}
    />
  );
};
